<template>
    <div class="saveOrUpdateCrud">
        <div v-show="!examRoomDoorPrintLook.visible">
            <!--搜索表单-->
            <div class="search-box selectType">
                <el-form ref="searchForm"  :inline="true" :model="searchForm" >
                    <el-form-item label="年份:" prop="year">
                        <el-date-picker
                                size="mini"
                                v-model="searchForm.year"
                                type="year"
                                placeholder="选择年份"
                                format="yyyy"
                                value-format="yyyy">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="考场号" prop="examRoomNum">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.examRoomNum" placeholder="请输入考场号" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="教室号" prop="classroomNum">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.classroomNum" placeholder="请输入教室号" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:examRoomDoorPrint-find @click="()=>{this.searchForm.pager.page=1;this.censusRoom();}">查询</el-button>
                        <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div style="margin-top: 20px;">
                <ul  class="schoolProcessList">
                    <li v-for="item in examRoomList">
                        <p>{{item.examRoomNum}}</p>
                        <p>{{item.classroomNum}}</p>
                        <p>考试人数:<span style="font-size: 20px;font-weight: bold;color: red">{{item.cnt}}</span>(人)</p>
                        <div class="oa-btn">
                            <el-button type="primary" title="预览考场门贴" v-display:examRoomDoorPrint-toLook @click="toLook(item.examRoomNum,item.classroomNum)">预览考场门贴</el-button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <exam-room-door-print-look v-if="examRoomDoorPrintLook.visible" v-bind="examRoomDoorPrintLook" @closeExamRoomDoorPrintLook="closeExamRoomDoorPrintLook"></exam-room-door-print-look>
    </div>
</template>

<script>
    import axios from 'axios'
    import html2canvas from 'html2canvas';
    import JsPDF from 'jspdf'
    import examRoomDoorPrintLook from "./examRoomDoorPrintLook.vue";
    let loading;
    export default {
        components: {examRoomDoorPrintLook},
        name: "examRoomDoorPrint",
        data(){
            return {
                searchForm:{
                    examRoomNum: '',
                    classroomNum: '',
                    pager:{
                        sortField:'examRoomNum',
                        sortOrder:'asc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'examRoomNum,classroomNum'
                    }
                },
                examRoomList:[],
                examRoomStudentList:[],
                roomName:'',
                config:config,
                examRooForm:{},
                examRoomDoorPrintLook:{
                    visible:false,
                    title:'考场门贴详情',
                    examRoomNum:'',
                    classroomNum:'',
                }
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.censusRoom();
        },
        mounted(){

        },
        methods:{
            censusRoom(){
                axios({
                    url:`${home}/sysExamRoom/censusRoom`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    this.examRoomList = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            toLook(examRoomNum, classroomNum){
                this.examRoomDoorPrintLook.title='考场门贴';
                this.examRoomDoorPrintLook.examRoomNum=examRoomNum;
                this.examRoomDoorPrintLook.classroomNum=classroomNum;
                this.examRoomDoorPrintLook.visible=true;
            },
            closeExamRoomDoorPrintLook(data){
                this.examRoomDoorPrintLook.visible=false;
                this.censusRoom();
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }

    .page {
        width: 21cm;
        min-height: 29.7cm;
        padding: 2cm;
        margin: 1cm auto;
        border: 1px #D3D3D3 solid;
        border-radius: 5px;
        background: white;
    }

    .subpage {
        padding: 1cm;
        height: 256mm;
    }

    .pageStyle {
        float: left;
        height: 275px;
        width: 46%;
        margin-top: 45px;
        margin-left: 30px;
    }
    .schoolProcessList {
        margin-top: 20px;
        list-style: none;
        // height: 100%;
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        margin-left: -4%;
        // margin-top: -5%;
        // align-content: space-around;
        li {
            border-radius: 6px;
            background: #f2f7ff;
            margin-left: 4%;
            // margin-top: 5%;
            width: 12.6%;
            text-align: center;
            margin-bottom: 4%;
            img {
                margin: 12% auto 10%;
                width: 55%;
            }
            .oa-btn .el-button {
                min-width: 60%;
                max-width: 90%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-left: 5%;
                padding-right: 5%;
                margin-bottom: 18%;
                border-radius: 50px;
                padding-top: 4.5%;
                padding-bottom: 4.5%;

            }
        }
    }

</style>